import { z } from 'zod';
import { ROLES } from '../enums.js';
// Política de contraseñas — mín 10 chars + complejidad (mayúsc + minúsc + número + símbolo).
// Es la regla que valida tanto el backend al guardar como el frontend al pedir.
export const passwordSchema = z
    .string()
    .min(10, 'La contraseña debe tener al menos 10 caracteres')
    .max(128, 'La contraseña no puede superar los 128 caracteres')
    .refine((p) => /[a-z]/.test(p), 'Falta una letra minúscula')
    .refine((p) => /[A-Z]/.test(p), 'Falta una letra mayúscula')
    .refine((p) => /\d/.test(p), 'Falta un dígito')
    .refine((p) => /[^A-Za-z0-9]/.test(p), 'Falta un símbolo');
// Email de acceso: cualquier dominio válido. (El template restringía a un dominio
// corporativo; acá las usuarias son dos personas con cuentas propias.)
export const emailSchema = z.string().email('Email inválido').max(254);
export const loginSchema = z.object({
    email: emailSchema,
    password: z.string().min(1, 'La contraseña es obligatoria'),
});
export const cambiarPasswordSchema = z
    .object({
    passwordActual: z.string().min(1, 'La contraseña actual es obligatoria'),
    passwordNuevo: passwordSchema,
    passwordNuevoConfirmacion: z.string(),
})
    .refine((d) => d.passwordNuevo === d.passwordNuevoConfirmacion, {
    message: 'Las contraseñas nuevas no coinciden',
    path: ['passwordNuevoConfirmacion'],
});
// Respuesta del endpoint /auth/me — datos del usuario logueado.
export const currentUserSchema = z.object({
    id: z.string(),
    email: z.string(),
    nombre: z.string(),
    rol: z.enum(ROLES),
    debeCambiarPassword: z.boolean(),
    // Sprint 10 — Slice D — URL relativa al endpoint que sirve el avatar, o null si
    // el usuario no subió foto. El frontend la consume tal cual (vía el cliente axios
    // que ya apunta a /api/v1) y nunca habla directo con MinIO.
    avatarUrl: z.string().nullable(),
});
//# sourceMappingURL=auth.js.map